module.exports = __webpack_public_path__ + "static/media/java.d419db0e.svg";